import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import SspContext from 'selfServicePortal/contexts/SspContext'

const WithdrawalNo = () => {
	const { t } = useTranslation()
	const { typeOfAccount, overviewData } = useContext(SspContext)

	return (
		<div className="container">
			<div className="fade-in outer-container p-4 mt-4">
				<div className="d-flex justify-content-between">
					<h5>{t('Withdrawal')}</h5>
				</div>
				{typeOfAccount(overviewData!.productId).product ===
					'Sparekonto' && (
					<div>
						{t('WithdrawalTextSavingsAccount')}
						<a
							href="https://tfbank.no/uttak-innskuddskonto"
							target="_blank"
							rel="noopener noreferrer">
							{t('WithdrawalLink')}
						</a>
					</div>
				)}
				{typeOfAccount(overviewData!.productId).product ===
					'Fastrentekonto' && (
					<div>
						{t('WithdrawalTextSavingsAccount')}
						<a
							href="https://tfbank.no/uttak-innskuddskonto"
							target="_blank"
							rel="noopener noreferrer">
							{t('WithdrawalLink')}
						</a>
					</div>
				)}
			</div>
		</div>
	)
}
export default WithdrawalNo

